
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 40 40"}},[_c('path',{attrs:{"d":"M12.323 2.339l-9.99 15.647 2.811 1.791 2.355-3.692v20.582h3.333V10.861l4.3-6.736zm19.343 16.828v-3.333h-5v-2.5h-3.333v2.5h-4.93v3.333h4.93v2.5h-5v10h13.333v-10h-5v-2.5zM28.333 25v3.339h-6.667v-3.333z"}}),_c('path',{attrs:{"d":"M33.333 8.339h-20v28.328h23.333V8.339zm-16.667 25V11.667h16.667v21.672z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      